import React from "react";
import { useAuth } from "../context/auth";
import Home from "../pages/home";
import Manages from "../manages/Login";

function Logout(props) {
	const { setAuthTokens } = useAuth();
	setAuthTokens(); 	
	localStorage.clear(); 		
	sessionStorage.clear(); 
	window.location.reload()		
	window.location.href='/Manages'	
	return false
}

export default Logout;